import { ReactNode } from 'react'

import Box from '~/core/Box'
import getColor from '~/lib/getColor'

type PropsType = {
    children: ReactNode
}

export default function PartLayoutContainer(props: PropsType) {
    const { children } = props

    return (
        <Box
            direction="col"
            width="100%"
            borderRadius="4px 0 0 4px"
            backgroundColor={getColor('viewerBackground')}
            minWidth="268px"
        >
            <Box height="100%" direction="col" justifyContent="between">
                {children}
            </Box>
        </Box>
    )
}
